import { useState } from 'react';

import { UNASSIGNED_VALUE, FILTER_ACTIONS } from '../common/filterTypes';

const useFilters = (allFields, filtersData) => {
    const [isFiltered, setIsFiltered] = useState(false);
    const filteredFields = { ...allFields };

    const filteredFieldsNames = Object.keys(filtersData).filter((fieldId) => {
        return (
            (filtersData[fieldId].type.action === FILTER_ACTIONS.INCLUDES && filtersData[fieldId].value !== '') ||
            (filtersData[fieldId].type.action === FILTER_ACTIONS.MATCH &&
                filtersData[fieldId].value !== undefined &&
                filtersData[fieldId].value !== null)
        );
    });

    if (filteredFieldsNames.length === 0) {
        if (isFiltered) {
            setIsFiltered(false);
        }
        return [false, allFields];
    } else {
        if (!isFiltered) {
            setIsFiltered(true);
        }
    }

    for (const tab in allFields) {
        const tabFields = allFields[tab].fields;
        for (const fieldId in tabFields) {
            const field = tabFields[fieldId];
            if (filteredFieldsNames.includes(field.id)) {
                const filteredField = filtersData[field.id];
                if (filteredField.arrayId) {
                    if (filteredField.value === UNASSIGNED_VALUE) {
                        if (!field.value.length) {
                            continue;
                        }
                    } else if (filteredField.type.action === FILTER_ACTIONS.MATCH) {
                        if (field.value.some((fields) => filteredField.value === fields[filteredField.arrayId].value)) {
                            continue;
                        }
                    } else if (filteredField.type.action === FILTER_ACTIONS.INCLUDES) {
                        if (
                            field.value.some(
                                (fields) =>
                                    fields[filteredField.arrayId].value &&
                                    fields[filteredField.arrayId].value
                                        .toLowerCase()
                                        .includes(filteredField.value.toLowerCase())
                            )
                        ) {
                            continue;
                        }
                    }
                } else if (
                    (filteredField.type.action === FILTER_ACTIONS.MATCH && filteredField.value === field.value) ||
                    (filteredField.type.action === FILTER_ACTIONS.INCLUDES &&
                        field.value &&
                        field.value.toLowerCase().includes(filteredField.value.toLowerCase()))
                ) {
                    continue;
                }
                delete filteredFields[tab];
                break;
            }
        }
    }

    return [isFiltered, filteredFields];
};
export default useFilters;
